/**
 * Monetization switches.
 *
 * COIN_PURCHASES_ENABLED — set to true to bring back direct coin-pack sales
 * (pricing page Coins tab, buy-coins modal, first-purchase pill, "see all
 * packages" links). While false the app sells subscriptions only; coins stay
 * as the internal metering unit granted by each subscription cycle, and every
 * out-of-coins moment routes to the subscription upsell instead of packs.
 * All coin-pack plumbing (billing config products, webhook crediting via
 * COIN_PACK_AMOUNTS, admin tools) stays intact and keeps honoring old IPNs.
 */
export const COIN_PURCHASES_ENABLED = true;

/** Headline discount shown on upgrade prompts (sidebar, promo card). */
export const UPGRADE_DISCOUNT_PERCENT = 54;
